import {Component, OnDestroy, OnInit,} from '@angular/core';
import {ViewportService} from 'src/app/services/viewport.service';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {ToastrService} from 'ngx-toastr';
export enum ShareHandler {
    CopyLink = 'copyLink',
    ShareEmail = 'shareEmail',
    ShareFacebook = 'shareFacebook',
    ShareX = 'shareX'
}
import { Router } from '@angular/router';

export interface ShareAction {
    label: string;
    icon: string;
    handler: ShareHandler;
    isCopy?: boolean;
}

export const SHARE_ACTIONS: ShareAction[] = [
    {
        label: 'Copy Link',
        icon: 'ph-thin ph-copy',
        handler: ShareHandler.CopyLink,
        isCopy: true
    },
    {
        label: 'Email',
        icon: 'ph-thin ph-envelope',
        handler: ShareHandler.ShareEmail
    },
    {
        label: 'Facebook',
        icon: 'ph-thin ph-facebook-logo',
        handler: ShareHandler.ShareFacebook
    },
    {
        label: 'Twitter',
        icon: 'ph-thin ph-x-logo',
        handler: ShareHandler.ShareX
    }
];
@Component({
    selector: 'share-deal-modal',
    templateUrl: './share-deal-modal.component.html',
    styleUrl: './share-deal-modal.component.css',
})
export class ShareDealModalComponent implements OnInit, OnDestroy {
    shareUrl = '';
    shareText = '';
    actions: ShareAction[] = SHARE_ACTIONS
    copied = false;


    constructor(
        public viewport: ViewportService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private toastr: ToastrService,
        private router: Router,
    ) {}

    ngOnInit() {
        this.shareUrl = this.config.data?.shareUrl ?? '';
        this.shareText = this.config.data?.shareText ?? '';
    }

    ngOnDestroy(): void {}

    close() {
        this.ref.close();
    }

    onActionClick(action: ShareAction): void {
        if (action.isCopy) {
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 2000);
        }

        switch (action.handler) {
            case ShareHandler.CopyLink:
                this.copyLink();
                break;
            case ShareHandler.ShareEmail:
                this.shareEmail();
                break;
            case ShareHandler.ShareFacebook:
                this.shareFacebook();
                break;
            case ShareHandler.ShareX:
                this.shareX();
                break;
        }
    }

    async copyLink(): Promise<void> {
        if (!this.shareUrl) {
            return;
        }

        if (!navigator.clipboard?.writeText) {
            this.toastr.error('Copy not supported in this browser');
            return;
        }

        try {
            await navigator.clipboard.writeText(this.shareUrl);
        } catch {
            this.toastr.error('Could not copy link');
        }
    }


    shareEmail(): void {
        const subject = 'Check out this flight deal I found';
        const body = `${this.shareText}\n\n${this.shareUrl}`;
        const mailto = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        this.copyLink();
        window.location.href = mailto;
        this.toastr.info(
            'If an email window didn’t open, just paste the draft we copied for you.',
            'Email draft copied'
        );
    }



    shareX(): void {
        const url =
            `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.shareText)}&url=${encodeURIComponent(this.shareUrl)}`;
        window.open(url, '_blank', 'noopener');
    }

    shareFacebook(): void {
        const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareUrl)}`;
        window.open(url, '_blank', 'noopener');
    }

    clickLearnMore(): void {
        this.router.navigate(["/referral"]);
        this.ref.close();
    }

}
